/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function() {
    function checkOtherOption() {
        var dropdowns = [
            { dropdown: '#aaa-form-builder-product', customInputContainer: '#customInputContainer1', customInput: '#customInput1' },
            { dropdown: '#aaa-form-builder-business-focus', customInputContainer: '#customInputContainer2', customInput: '#customInput2' },
            { dropdown: '#aaa-form-builder-promote-yokkao-products', customInputContainer: '#customInputContainer3', customInput: '#customInput3' },
            { dropdown: '#aaa-form-builder-additional-support', customInputContainer: '#customInputContainer4', customInput: '#customInput4' }
        ];
        dropdowns.forEach(function(item) {
            if ($(item.dropdown).val() === 'Other (please specify)') {
                $(item.customInputContainer).show();
               $(item.customInputContainer).find("input").prop("required","required");
            } else {
                $(item.customInputContainer).hide();
              $(item.customInputContainer).find("input").removeAttr("required");
                $(item.customInput).val('');
            }
        });
    }
    $('#aaa-form-builder-product, #aaa-form-builder-business-focus, #aaa-form-builder-promote-yokkao-products, #aaa-form-builder-additional-support').change(function() {
        checkOtherOption();
    });
    checkOtherOption();
});


/*** yes button click function ****/
  $(document).on('click','.yes_retail_btn',function(e){
    e.preventDefault();
    var $this = $(this);
   var inventory_qty = $.trim($('.inventory_qty',this).attr('data-inventorytoAdd'));
   var selected_product =$(this).parents('.inventory_alert_popup').attr('data-variant');
   
    if($(this).parents(".inventory_alert_popup").hasClass("cart-drawer")){
      //do nothing
       $('.CartItem__QuantitySelector .custom__plus.QuantitySelector__CurrentQuantity[data-id="'+selected_product+'"]').val(inventory_qty);   
    }else{
       $('.ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity').val(inventory_qty);   
    }
     $(this).parents('.inventory_alert_popup').removeClass('active');
  
    // $('.all_product_get[data-var-id="'+selected_product+'"]')[0].click();
    // if(window.location.href.indexOf('cart') > -1){
    //   $('form[action="/cart"]').submit();
    // }else{
       if($this.parents(".inventory_alert_popup").hasClass("cart-drawer")){
      //do nothing
         addProductRetailCart(selected_product,inventory_qty);
  
    }else{
        var main_text1 = $('.ProductForm__AddToCart');
        var text = $('.ProductForm__AddToCart').attr("data-attr");
        main_text1.text("Adding in Cart...");
          addProductRetail(selected_product,inventory_qty,main_text1,text);
       }
     
   // }
    
     return false;
});
  /*** yes button click function end here ***/
  /*** no button click function ****/
 $(document).on('click','.no_retail_btn',function(e){
    e.preventDefault();
    var selected_product =$(this).parents('.inventory_alert_popup').attr('data-variant');
    if($(this).parents(".inventory_alert_popup").hasClass("cart-drawer")){
       $('.CartItem__QuantitySelector .QuantitySelector__CurrentQuantity').removeClass('input--error');
    }else{
      $('.ProductForm__QuantitySelector .QuantitySelector__CurrentQuantity').removeClass('input--error');
    }
    
   $(this).parents('.inventory_alert_popup').removeClass('active');

   if($(this).parents(".inventory_alert_popup").hasClass("cart-drawer")){
     var newQTY = $(this).parents(".inventory_alert_popup").attr("data-old-qty");
     //alert(newQTY+"==="+selected_product);
      $('input.QuantitySelector__CurrentQuantity[data-id="'+selected_product+'"]').val(newQTY); 
      addProductRetailCart(selected_product,newQTY);
  
   }
    // if(window.location.href.indexOf('cart') > -1){
    //    var newQTY =parseInt($.trim($('.custom__plus.QuantitySelector__CurrentQuantity[data-id="'+selected_product+'"]').attr('data-qty')));  
    //      $('.custom__plus.QuantitySelector__CurrentQuantity[data-id="'+selected_product+'"]').val(newQTY);       
    // }
   return false;
});


 function addProductRetailCart(main_pro_id,qty_val){
  /* var stock = 0;
   var preorder = false;
    
     stock = $(".CartItem__QuantitySelector .QuantitySelector__CurrentQuantity[data-id="+main_pro_id+"]").attr("data-inv-qty");
     preorder = $(".CartItem__QuantitySelector .QuantitySelector__CurrentQuantity[data-id="+main_pro_id+"]").attr("data-preOrder");
          
 var properties ={};
    
   if(stock > 0 ){
      if($.trim(preorder) == 'true' ){
      properties['IN-STOCK'] = stock;
      properties['PRE-ORDER'] = qty_val - stock;
     }else{
        if(qty_val >= stock){
           properties['IN-STOCK'] = stock;     
        }
     }
   }else{
     if($.trim(preorder) == 'true' ){
       properties['PRE-ORDER'] = qty_val;
     }
   }
   */
    jQuery.ajax({  
      type: 'POST',
      url: '/cart/change.js',
      data:{
        id: main_pro_id,
        quantity: qty_val,
         properties: properties,
      },
      dataType: 'json',
      success: function(productid){       
         // window.location.href='/cart';
          jQuery.getJSON('/cart.js', function(cart) {
             document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true , 
                detail: {
                variant: main_pro_id,
                quantity: qty_val
                }
                }));  
             $(".Header__CartCount").html(cart.item_count);
          });
         return false;
     },
      error:function(error){
         var error_msg = error.responseJSON.description;
              var stock= 0;
        
           var stock = $(".CartItem__QuantitySelector .QuantitySelector__CurrentQuantity[data-id="+main_pro_id+"]").attr("data-inv-qty");
            console.log(stock);
         
            if(error_msg.indexOf("You can't add more") != -1){
              error_msg  = "We currently have "+stock+" item(s) in the stock. Please reduce the quantity." ;
            }
         main_text1.text(text);
        //alert(error.responseJSON.description);
        $('.inventory_error').addClass('active');
        $('.inventory_error h3').text(error_msg);
        main_text1.parents('.quantity__variant').find('.quantity__input').addClass('input--error');
        //main_text1.parents('td').append('<p class="cart_error error">'+error.responseJSON.description+'</p>');
          // setTimeout(function(){$('.cart_error').remove();},5000)
     }
    }); 
  }


 function addProductRetail(main_pro_id,qty_val,main_text1,text){
   /*
   var stock = 0;
   var preorder = false;
    $(".for_variant_avail_or_no option").each(function(){
      var inventory = $.trim($(this).attr("data-vv-id"));   
    if(main_pro_id==inventory){
      stock= parseInt($(this).attr("data-inv-qty"));
      preorder= $.trim($(this).attr("data-preOrder"));
    }
  });
 var properties ={};
    
   if(stock > 0 ){
      if($.trim(preorder) == 'true' ){
      properties['IN-STOCK'] = stock;
      properties['PRE-ORDER'] = qty_val - stock;
     }else{
        if(qty_val >= stock){
           properties['IN-STOCK'] = stock;     
        }
     }
   }else{
     if($.trim(preorder) == 'true' ){
       properties['PRE-ORDER'] = qty_val;
     }
   }
   */
    jQuery.ajax({  
      type: 'POST',
      url: '/cart/add.js',
      data:{
        id: main_pro_id,
        quantity: qty_val,
      },
      dataType: 'json',
      success: function(productid){
        if($(".inventory_alert_popup.active").hasClass("cart-drawer")){
          //do nothing
        }else{
            console.log(main_text1);
             main_text1.text("Added To Cart");
         setTimeout(function() {           
           main_text1.text(text);
            }, 2500);
        }
         // window.location.href='/cart';
        
           jQuery.getJSON('/cart.js', function(cart) {
             $(".Header__CartCount").html(cart.item_count);
          });
          //window.location.href='/cart';
        
         return false;
     },
      error:function(error){
         var error_msg = error.responseJSON.description;
              var stock= 0;
          if($(".inventory_alert_popup.active").hasClass("cart-drawer")){
    
           var stock = $(".CartItem__QuantitySelector .QuantitySelector__CurrentQuantity[data-id="+main_pro_id+"]").attr("data-inv-qty");
            console.log(stock);
          }else{
        
            $(".for_variant_avail_or_no option").each(function(){
              var inventory = $(this).attr("data-vv-id");
             console.log(main_pro_id+"==="+inventory);
              if(main_pro_id==inventory){
                stock = parseInt($(this).attr("data-inv-qty"));
              }
            });
            }
            console.log(stock);
            if(error_msg.indexOf("You can't add more") != -1){
              error_msg  = "We currently have "+stock+" item(s) in the stock. Please reduce the quantity." ;
            }
         main_text1.text(text);
        //alert(error.responseJSON.description);
        $('.inventory_error').addClass('active');
        $('.inventory_error h3').text(error_msg);
        main_text1.parents('.quantity__variant').find('.quantity__input').addClass('input--error');
        //main_text1.parents('td').append('<p class="cart_error error">'+error.responseJSON.description+'</p>');
          // setTimeout(function(){$('.cart_error').remove();},5000)
     }
    }); 
  }